import type { FC, PropsWithChildren } from 'react'

import { TranslationContext } from '@core/i18n/context'
import { useTranslation } from '@core/widgets/i18n'

/**
 *
 */
export const WidgetTranslationWrapper: FC<PropsWithChildren> = ({
  children,
}) => (
  <TranslationContext.Provider value={useTranslation()}>
    {children}
  </TranslationContext.Provider>
)
